// extracted by mini-css-extract-plugin
export default {"root":"button_root__-06bs"};